import * as Y from "yjs";
import config from "@/config";
import { WebsocketProvider } from 'y-websocket'

class YjsService {

  wsp;
  mouseTracker;
  doc;

  getConnectedDoc(roomId) {
    
    let _self = this;
    _self.doc = new Y.Doc();
    
    this.wsp = new WebsocketProvider(config.YJS_WEBSOCKET, roomId, _self.doc,  {maxBackoffTime: 3600000, auth:roomId});
    // this.wsp = new WebrtcProvider(roomId, _self.doc, { signaling: [config.YJS_WEBSOCKET] })

    // return new Promise((res, rej) => {
    //   // this.wsp = new WebrtcProvider(roomId, _self.doc, { signaling: [config.YJS_WEBSOCKET] })
    //   res(_self.doc);
    // });
    
    return new Promise((res, rej) => {
      this.wsp.on("status", e => {
        e.status === "connected" ? _self.wsp.on("sync", () => res(_self.doc)) : rej()
      });
    });
  }

  startAwareness({ username, listener }) {
    this.wsp.awareness.setLocalState({ user: { name: username, color: 'blue' }, roomCursor: { x: 0, y: 0 } });
    this.wsp.awareness.on("change", changes => {
      listener.apply(null, [changes, this.wsp.awareness.getStates()]);
    });
    this.mouseTracker = event => {
      var state = this.wsp.awareness.getLocalState();
      if (state != null) {
        state.roomCursor.x = event.pageX;
        state.roomCursor.y = event.pageY + document.querySelector(".header_row").scrollTop;
        this.wsp.awareness.setLocalState(state);
      }
    };
    window.addEventListener("mousemove", this.mouseTracker);
  }

  stopAwareness() {
    this.wsp.awareness.destroy();
    window.removeEventListener("mousemove", this.mouseTracker);
  }
}

export default YjsService;